


const Description = ({ description, desc }) => {
    const filterDesc = description.substring(0, desc?.limit);
    return desc?.show && <div className="videosDes">
        <p>{filterDesc}</p>
    </div>
}
export default Description;